import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Tx } from "src/redux/Tx/types";
import CollapsibleMenu from "src/components/common/CollapsibleMenu";
import {
    getFromLocalUserStorage,
    saveLocalUserStorage,
    removeLocalUserStorage,
} from "src/utils/localStorage";

import styles from "./styles.module.scss";
import Dropdown from "src/components/common/Dropdown";
import { SettingsSelectors } from "src/redux/Settings/selectors";

export default () => {
    const initialFund = getFromLocalUserStorage(Tx.FUND_CODE_STORAGE_VALUE);
    const fund = useSelector(SettingsSelectors.FundSettings).map((c) => ({
        label: c.fundName,
        value: c.fundName,
    }));

    const options = [{ label: "None", value: null }].concat(fund);
    const [fundCode, setFundCode] = useState(null);

    useEffect(() => {
        const isFundExists = fund.some((f) => f.value === initialFund.value);
        if (!fundCode && isFundExists) {
            setFundCode(initialFund);
        } else if (!isFundExists) {
            removeLocalUserStorage(Tx.FUND_CODE_STORAGE_VALUE);
        }
    }, [fundCode, initialFund]);

    return (
        <CollapsibleMenu title="Fund" allowsOverflow>
            <div className={styles.section}>
                <Dropdown
                    mainStyle="thick-black"
                    value={fundCode}
                    options={options}
                    placeholder="Select Fund"
                    onChange={(e) => {
                        const value = e.value ? e : {};
                        setFundCode(value);
                        saveLocalUserStorage(Tx.FUND_CODE_STORAGE_VALUE, value);
                    }}
                    dataTestId="tx-init-fund-code"
                    ariaLabel="Select Fund"
                />
            </div>
        </CollapsibleMenu>
    );
};
